import { render, staticRenderFns } from "./ToLink.vue?vue&type=template&id=7f5a7278&scoped=true"
import script from "./ToLink.vue?vue&type=script&lang=js"
export * from "./ToLink.vue?vue&type=script&lang=js"
import style0 from "./ToLink.vue?vue&type=style&index=0&id=7f5a7278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5a7278",
  null
  
)

export default component.exports